// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_BuscaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/traducoes/busca.
 * `total` is every match; `mais` says the list was truncated to `limite`.
 */
import type { Traducoes_ItemRow } from './Traducoes_ItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Traducoes_BuscaResponseDados {
itens: Traducoes_ItemRow[]
total: number
mais: boolean
}

export type Traducoes_BuscaResponse = ApiResponse<Traducoes_BuscaResponseDados>;

registerResponseContract('Traducoes_BuscaResponse', {
  itens: {
    type: 'array',
    required: true,
    items: {
      pagina:    { type: 'string',  required: false },
      chave:     { type: 'string',  required: false },
      traducoes: { type: 'object',  required: false },
      faltantes: { type: 'array',   required: false },
    },
  },
  total: { type: 'number',  required: true },
  mais:  { type: 'boolean', required: true },
})
